module.exports = __webpack_public_path__ + "images/2a73537fc5cdf61333498714ab67c921-logo_wide.png";